import React from 'react'

import {
  Card,
  CardContent,
  CircularProgress,
  Typography
} from '@mui/material'
import { makeStyles } from '@mui/styles'

interface AlertBaseProps {
  status: 'error' | 'success' | 'warning'
  title: string
  count: number
  countDescription?: string
  loading?: boolean
  onClick?: () => void
}

export const AlertBase: React.FC<AlertBaseProps> = ({
  status,
  title,
  count,
  countDescription,
  loading,
  onClick
}) => {
  const classes = useStyles({ status })
  return (
    <Card elevation={0} className={classes.card} onClick={onClick}>
      <CardContent className={classes.cardContent}>
        <div className={classes.cardContentText}>
          <Typography
            variant='caption'
            style={{
              width: '100%'
            }}
          >
            {title}
          </Typography>
        </div>
        <div className={classes.cardContentText2}>
          {!loading && (
            <Typography variant='body2' component='h6'>
              {count} {countDescription}
            </Typography>
          )}
          {loading && <CircularProgress size={'14px'} />}
        </div>
      </CardContent>
    </Card>
  )
}

const useStyles = makeStyles((_theme) => ({
  card: {
    // minWidth: 275,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5' // Change this color to your desired hover background color
    },
    border: '1px solid lightgray',
    padding: '5px'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  cardContentText: (props: { status: 'error' | 'success' | 'warning' }) => ({
    color:
      props.status === 'error'
        ? 'lightcoral'
        : props.status === 'success'
        ? 'rgb(153, 255, 133)'
        : 'rgb(252, 177, 14)',
    backgroundColor:
      props.status === 'error'
        ? 'rgba(255, 189, 189, 0.1)'
        : props.status === 'success'
        ? 'rgba(153, 255, 133, 0.1)'
        : 'rgba(250, 234, 144, 0.1)',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center the title vertically
    justifyContent: 'flex-start', // Center the title horizontall,
    borderRadius: '5px',
    padding: '5px',
    textAlign: 'center'
  }),
  cardContentText2: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center the title vertically
    justifyContent: 'center' // Center the title horizontall,
  }
}))
